import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const styles = {
  header: {
    borderBottom: '2px solid var(--color-border)',
    padding: '16px 0',
    marginBottom: '24px',
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '16px',
  },
  logo: {
    fontSize: '1.5rem',
    fontWeight: '700',
    textDecoration: 'none',
    color: 'var(--color-primary)',
  },
  nav: {
    display: 'flex',
    gap: '24px',
  },
  navLink: {
    fontWeight: '600',
    color: 'var(--color-primary)',
    textDecoration: 'none',
    padding: '4px 0',
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.15s',
  },
  navLinkActive: {
    borderColor: 'var(--color-primary)',
  },
  createBtn: {
    padding: '10px 20px',
    background: 'var(--color-primary)',
    color: 'var(--color-bg)',
    border: '2px solid var(--color-primary)',
    fontWeight: '600',
    textDecoration: 'none',
    display: 'inline-block',
  },
}

export default function Header() {
  const location = useLocation()

  const isActive = (path) => location.pathname === path

  return (
    <header style={styles.header} className="no-print">
      <div style={styles.inner}>
        <Link to="/" style={styles.logo}>
          Kellyword
        </Link>

        <nav style={styles.nav}>
          <Link
            to="/"
            style={{
              ...styles.navLink,
              ...(isActive('/') ? styles.navLinkActive : {}),
            }}
          >
            Browse
          </Link>
          <Link
            to="/create"
            style={styles.createBtn}
          >
            + Create Puzzle
          </Link>
        </nav>
      </div>
    </header>
  )
}
